// extracted by css-extract-rspack-plugin
export default {"root":"DeO5L","description":"hS7Mq","error":"WQ_qq","label":"sGskH","body":"UNSWZ","track":"n8uLc","labelWrapper":"vV7zR","thumb":"Czmin"};